import { COLORS } from '../../config';

export const ToolBarView = (props) => {
    return (
      <div className={`flex flex-col items-start xl:flex-row justify-between xl:items-center content-center`}>
          <div className="pt-4 text-4xl text-secondary mb-8">My Appointments</div>
          <div className='mb-4 xl:mb-0 flex flex-col-reverse sm:flex-row items-start sm:items-center content-center'>
            <div className='flex'>
              <span className="rbc-toolbar-label text-xl pr-4">{props.label}</span>
              <button className='flex items-center cursor-pointer justify-center rounded-md px-2 h-6 mr-1 bg-gray-200 hover:bg-primary icon-container' 
                onClick={() => props.onNavigate('PREV')}>
                <svg xmlns="http://www.w3.org/2000/svg" className='icon-style' viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </button>
              <button className='flex items-center cursor-pointer justify-center rounded-md px-2 h-6 bg-gray-200 hover:bg-primary icon-container mr-4 ml-1' 
                onClick={() => props.onNavigate('NEXT')}>
                <svg xmlns="http://www.w3.org/2000/svg" className='icon-style' viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
              </button>
            </div>
            <div className="filter-container sm:ml-2 mt-2 sm:mt-0">
              <span onClick={() => props.onView('day')} style={props.view === 'day'? {background: COLORS.colorPrimary} : {}} className={`${props.view === 'day'? 'rounded text-xl text-white px-5': 'text-xl'} cursor-pointer`}>Day</span>
              <span onClick={() => props.onView('week')} style={props.view === 'week'? {background: COLORS.colorPrimary} : {}} className={`${props.view === 'week'? 'rounded text-xl text-white mx-5 px-5':"text-xl mx-5"} cursor-pointer`}>Week</span>
              <span onClick={() => props.onView('month')} style={props.view === 'month'? {background: COLORS.colorPrimary} : {}} className={`${props.view === 'month'? 'rounded text-xl text-white px-5':"text-xl"} cursor-pointer `}>Month</span>
              {/* <span onClick={() => props.onView('agenda')} style={props.view === 'agenda'? {background: COLORS.colorPrimary} : {}} className={props.view === 'agenda'? 'rounded text-xl text-white px-5':"text-xl"}>Agenda</span> */}
            </div>
          </div>
      </div>
    )
}
  